import React from 'react'

import PopupWrapper from 'Components/PopupWrapper/PopupWrapper'

const PriorityCell = ({ ticket, keyClient }) => {
  let priorityCell = ticket.priority_id

  if (ticket.priority_predicted) {
    priorityCell = (
      <React.Fragment>
        <b>
          {ticket.priority_id}
          &nbsp;
        </b>
        <PopupWrapper
          trigger={<span className="lnr lnr-star-half lnr--left-spaced" />}
          options={
            {
              on: 'hover',
              contentStyle: {
                padding: '0',
                borderRadius: '5px',
                width: 'auto',
                backgroundColor: 'transparent',
                border: 'none',
                boxShadow: 'none'
              }
            }
          }
        >
          <div>
            Suggested by Cloudhelp Assistant
          </div>
        </PopupWrapper>
        <span>&nbsp;</span>
        {keyClient &&
          (
            <PopupWrapper
              trigger={<span className="lnr lnr-key lnr--left-spaced" />}
            >
              <div>
                Key client
              </div>
            </PopupWrapper>
          )
        }
      </React.Fragment>
    )
  } else {
    priorityCell = (
      <React.Fragment>
        {ticket.priority_id}
        {keyClient &&
          (
            <PopupWrapper
              trigger={<span className="lnr lnr-key lnr--left-spaced" />}
            >
              <div>
                Key client
              </div>
            </PopupWrapper>
          )
        }
      </React.Fragment>
    )
  }

  return priorityCell
}

export default PriorityCell